import { statusService } from '../../helpers/services/registrationStatus.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const REGISTRATION_STATUS_MODULE = 'registrationStatus';

// define action 
export const GET_ALL_REGISTRATION_STATUS = 'getAllRegistartions';
export const GET_REGISTRATION_STATUS = 'getRegistration';
export const UPDATE_REGISTRATION_STATUS = 'updateRegistration';
export const CREATE_REGISTRATION_STATUS = 'createRegistration';
export const UPDATE_REGISTRATION_STATUS_STATUS = 'updateRegistrationStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_REGISTRATION_STATUS_REQUEST = "getAllRegistrationStatus";
const GET_REGISTRATION_STATUS_REQUEST = "getRegistrationStatus";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_REGISTRATION_STATUS]({ commit }, { filter }) {
        statusService
            .getAllStatuses(filter)
            .then(
                (result) => {
                    commit(GET_ALL_REGISTRATION_STATUS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_REGISTRATION_STATUS]({ commit }, { id }) {
        await statusService
            .getStatus(id)
            .then(
                (result) => {
                    commit(GET_REGISTRATION_STATUS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_REGISTRATION_STATUS]({ commit }, { data }) {
        commit(REQUEST)
        statusService
            .updateStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.registrationStatus')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_REGISTRATION_STATUS]({ commit }, { data }) {
        commit(REQUEST)
        statusService
            .createStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess", [i18n.t('module.registrationStatus')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_REGISTRATION_STATUS_STATUS]({ dispatch }, { filter, data }) {
        statusService
            .updateStatusStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_REGISTRATION_STATUS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Registration-status-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_REGISTRATION_STATUS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_REGISTRATION_STATUS_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            name: o.name,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at)
        }

    }
}


